export const API_BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://api.agarly.net";

export const CLOUDINARY_UPLOAD_URL =
  process.env.REACT_APP_CLOUDINARY_URL ||
  "https://api.cloudinary.com/v1_1/djnhviw5w/image/upload";

export const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_PRESET || "products_gallery";
